import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: 'input[TyaNumberVNInput]',
})
export class TyaNumberVNInputDirective {

  constructor(private _inputEl: ElementRef) { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    if (this._inputEl.nativeElement.value === '-') return;
    let valueInput: string = this._inputEl.nativeElement.value;
    let toNumber: number;
    let toLocale: string;

    valueInput = valueInput.replace(/\./g, '');
    valueInput = valueInput.replace(/\,/g, '.'); //đổi dấu , thành dấu chấm

    if (valueInput.slice(-1) != '.') { // chỉ trường hợp có thể chuyển thành số mới chạy thôi nha!
      toNumber = parseFloat(valueInput);
      toLocale = toNumber.toLocaleString('vi-VN');

      if (toLocale === 'NaN') {
        this._inputEl.nativeElement.value = '';
      }
      else {
        this._inputEl.nativeElement.value = toLocale;
      }
    }
  }
}
